var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-divider',_vm._b({style:({
    borderColor: _vm.grey ? '' : _vm.$vuetify.theme.themes[_vm.theme][_vm.color].base,
  })},'v-divider',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }